export const AVOCAT_LINK = "https://justicelib.com/?utm_source=qalimo%20";
